module.exports = __webpack_public_path__ + "static/img/1.9e2cdb1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/zh/1.png
// module id = KT0h
// module chunks = 0